import {createBrowserHistory} from 'history';
import appConfig from '../../config';

const history = createBrowserHistory({basename: appConfig.microfrontBasePath || ''});

export default history;
